/** @format */
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react"
import { useState } from "react"
import { Backdrop, Box, Fade, Grid, Modal, Paper } from "@mui/material"
import { HighlightOff } from "@mui/icons-material"

import TextOfferForms from "./offerForms"
import CustomButtonRounded from "../CustomButtonRounded"
import AppointmentModal from "../../Coupons/appointmentModal"
import ErrorMessage from "../../Coupons/errorMessage"
import SuccessMessage from "../../Coupons/successMessage"

export const CouponTextButton = ({
    coupon,
    coupons,
    storeId,
    store,
    disabled = false,
}) => {
    const [openText, setOpenText] = useState(false)
    const [apiCall, setApiCall] = useState({
        isSuccess: false,
        isError: false,
    })
    const [openAppointments, setOpenAppointments] = useState(false)

    const handleOpenText = () => setOpenText(true)
    const handleCloseText = () => setOpenText(false)

    const handleApiCall = (update) => {
        setApiCall({ ...apiCall, ...update })
    }

    if (!coupon && !coupons) return null

    return (
        <>
            <CustomButtonRounded
                fullWidth
                disabled={disabled}
                variant="outlined"
                color="primary"
                handleOnClick={handleOpenText}
                sxProps={{
                    fontWeight: "700",
                    "&:hover": {
                        borderColor: "white",
                        borderWidth: 2,
                    },
                    "&:disabled": {
                        color: "textPrimary.main",
                    },
                }}
            >
                Text
            </CustomButtonRounded>
            <Modal
                open={openText}
                onClose={handleCloseText}
                closeAfterTransition
                slots={{ backdrop: Backdrop }}
                slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Fade in={openText}>
                    <Paper
                        className={`${
                            apiCall.isSuccess
                                ? "animation-flipOver-success"
                                : apiCall.isError
                                ? "animation-flipOver-error"
                                : ""
                        } flip-card`}
                        sx={{
                            position: "relative",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            maxWidth: "500px",
                            borderRadius: 2,
                            boxShadow: 24,
                            perspective: "5000px",
                            transformStyle: "preserve-3d",
                        }}
                    >
                        <AppointmentModal
                            openAppointments={openAppointments}
                            handleCloseAppointments={() => {
                                setOpenAppointments(false)
                                handleCloseText()
                            }}
                            storeId={storeId}
                            store={store}
                        />
                        <Grid
                            container
                            className="flip-card-front"
                            alignItems="center"
                            sx={{
                                height: "auto",
                                p: 4,
                                bgcolor: "primary.main",
                                borderRadius: 2,
                                boxShadow: 24,
                            }}
                        >
                            <HighlightOff
                                css={css`
                                    position: absolute;
                                    right: -9px;
                                    top: 3px;
                                    width: 60px;
                                    height: 30px;
                                    cursor: pointer;
                                    color: #ebebeb;
                                `}
                                onClick={handleCloseText}
                            />
                            <Grid
                                item
                                xs={12}
                                sx={{
                                    p: 2,
                                    bgcolor: "#ebebeb",
                                    borderRadius: 2,
                                    boxShadow: 24,
                                }}
                            >
                                <TextOfferForms
                                    storeId={storeId}
                                    store={store}
                                    coupon={coupon}
                                    coupons={coupons}
                                    handleApiCall={handleApiCall}
                                    handleCloseText={handleCloseText}
                                />
                            </Grid>
                        </Grid>
                        <Grid
                            container
                            className="flip-card-back"
                            sx={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                height: "100%",
                                justifyContent: "center",
                                bgcolor: "#ebebeb",
                                borderRadius: 2,
                                boxShadow: 24,
                            }}
                        >
                            <Grid item xs={12}>
                                <HighlightOff
                                    css={css`
                                        position: absolute;
                                        right: -9px;
                                        top: 5px;
                                        width: 60px;
                                        height: 30px;
                                        cursor: pointer;
                                        color: #af0e11;
                                        &:hover {
                                            color: #006bb7;
                                        }
                                    `}
                                    onClick={handleCloseText}
                                />
                            </Grid>
                            {!apiCall.isError && (
                                <SuccessMessage
                                    setOpenAppointments={setOpenAppointments}
                                />
                            )}
                            {apiCall.isError && <ErrorMessage />}
                        </Grid>
                    </Paper>
                </Fade>
            </Modal>
        </>
    )
}
